export const ITEMS_PER_PAGE = 16
export const ITEMS_PER_PAGE_TABLET = 15
export const ITEMS_PER_SECTION = 5

export const TRACE_HTTP_STATUS_CODE = 'http.status_code'
export const TRACE_HTTP_METHOD = 'http.method'
export const TRACE_HTTP_TARGET = 'http.target'
export const TRACE_HTTP_URL = 'http.url'
